export function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts: string[] = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()!.split(';').shift();
}

export function formatTime(time: string | undefined): string {
  if (time === null || time === undefined)
      return "-";

  let parts = time.split("T")[1].slice(0, time.split("T")[1].length-1).split(':');
  return parts[1] + ':' + parts[2];
}

export function numWord(value: number, words: string[]){  
	value = Math.abs(value) % 100; 
	var num = value % 10;
	if (value > 10 && value < 20) return words[2]; 
	if (num > 1 && num < 5) return words[1];
	if (num === 1) return words[0]; 
	return words[2];
}